<template>
  <header class="header">
    <img class="header-img" src="../assets/img/logo.png" alt="Logo" />
    <h1 class="seo-title">Not So Good Stats</h1>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>
